import { api, apiWithoutContentType } from './client';

// Student Diary (Learning Zone > Digital Diary). Both calls are scoped to the
// logged-in student by the backend - there is no student id to pass.

// The shared client aborts requests after 30s, which would cut off a video
// upload mid-way. Give uploads 5 minutes (matches nginx's proxy_read_timeout).
const DIARY_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

// `formData` carries: type ('text' | 'video' | 'audio' | 'photo'), title, note,
// plus `content` for text entries or `file` for video / audio / photo entries.
export const createDiaryEntry = async (formData) => {
  try {
    const response = await apiWithoutContentType.post('/api/v1/diary', formData, {
      timeout: DIARY_UPLOAD_TIMEOUT_MS,
    });
    return response.data;
  } catch (error) {
    console.error('Error saving diary entry:', error);
    throw error;
  }
};

// Newest first. Resolves to { success, data: { entries, pagination: { page, limit, total, totalPages } } }.
export const getMyDiaryEntries = async (params = {}) => {
  try {
    const response = await api.get('/api/v1/diary', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching diary entries:', error);
    throw error;
  }
};
